<template>
  <div class="distribution-posters">
    <div class="header-nav ub no-warp">
      <div
        :class="['nav-item uf1', imgCateActiveIndex === index ? 'active' : '']"
        v-for="(item, index) in imgCate"
        :key="index"
        @click="getIndex(index)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="slider-banner banner">
      <swiper class="swiper-wrapper" :options="swiperPosters" ref="mySwiper">
        <swiperSlide
          class="swiper-slide"
          v-for="(item, index) in info"
          :key="index"
        >
          <img
            class="slide-image"
            @click="careteMyposter(item.img + '!content')"
            :src="item.img + '!content'"
          />
        </swiperSlide>
      </swiper>
    </div>
    <!--<div class="keep bg-color-red" @click="saveImg">保存海报</div>-->
    <div class="preserve acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="tip">点击生成我的推广海报</div>
      <div class="line"></div>
    </div>
    <MyPoster
      @setPosterImageStatus="posterImageStatus = false"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></MyPoster>
  </div>
</template>
<style lang="scss" scoped>
.header-nav {
  background: white;
  position: fixed;
  z-index: 99;
  width: 100%;
  overflow-scrolling: auto;
  box-shadow: 2px 2px 5px #333333;
  .nav-item {
    text-align: center;
    padding: 0.2rem;
    box-sizing: border-box;
  }
  .active {
    position: relative;
    &::after {
      width: 80%;
      position: absolute;
      content: "";
      border-bottom: 0.1rem red solid;
      bottom: -0.05rem;
      left: 10%;
    }
  }
}
.preserve {
  color: #fff;
  text-align: center;
  margin-top: 0.25rem;
}
.preserve .line {
  width: 1rem;
  height: 0.01rem;
  background-color: #fff;
}
.preserve .tip {
  margin: 0 0.3rem;
}
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getProductCode } from "@api/store";
import MyPoster from "@components/MyPoster";
import "@assets/css/swiper.min.css";
import { getPosterClass, posterImgList } from "../../../api/user";
export default {
  name: "Poster",
  components: {
    swiper,
    swiperSlide,
    MyPoster
  },
  props: {},
  data: function() {
    return {
      posterData: {
        image: "//aijiutang.oss-cn-beijing.aliyuncs.com/static_img/315-3.jpg",
        code: "",
        uid: 0
      },
      posterImageStatus: false,
      swiperPosters: {
        speed: 1000,
        effect: "coverflow",
        slidesPerView: "auto",
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0, // 旋转的角度
          stretch: -20, // 拉伸   图片间左右的间距和密集度
          depth: 100, // 深度   切换图片间上下的间距和密集度
          modifier: 3, // 修正值 该值越大前面的效果越明显
          slideShadows: false // 页面阴影效果
        },
        observer: true,
        observeParents: true
      },
      info: [],
      activeIndex: 0,
      imgCate: {},
      imgCateActiveIndex: 0,
      posters: false
    };
  },
  mounted: function() {
    getPosterClass()
      .then(r => {
        this.imgCate = r.data || {};
      })
      .catch(err => {
        console.log(err);
      });
    this.getIndex();
    let that = this;
    this.swiper.on("slideChange", function() {
      that.activeIndex = that.swiper.activeIndex;
    });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    careteMyposter(img) {
      console.log("img", img);
      this.posterData.image = img;
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      getProductCode({
        id: 0,
        img_to_base64_url: this.posterData.image
      })
        .then(res => {
          if (!res.data) return;
          this.posterData["image"] = res.data.image;
          this.posterData["code"] = res.data.code;
          this.posters = true;
          this.posterImageStatus = !this.posterImageStatus;
        })
        .catch(() => {
          this.posterImageStatus = !this.posterImageStatus;
          this.posters = false;
        });
    },
    getIndex(index) {
      if (index) {
        this.imgCateActiveIndex = index;
      }
      posterImgList({ class_id: index }).then(
        res => {
          this.info = res.data;
        },
        err => {
          this.$dialog.message(err + ":没有数据");
        }
      );
    }
    // downloadIamge: function(imgsrc, name) {
    //   let image = new Image();
    //   image.setAttribute("crossOrigin", "anonymous");
    //   image.onload = function() {
    //     let canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     let context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    //     let a = document.createElement("a"); // 生成一个a元素
    //     let event = new MouseEvent("click"); // 创建一个单击事件
    //     a.download = name || "photo"; // 设置图片名称
    //     a.href = url; // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event); // 触发a的单击事件
    //   };
    //   image.src = imgsrc;
    // },
    // saveImg: function() {
    //   console.log(this.info[this.activeIndex].wap_poster);
    //   this.downloadIamge(
    //     this.info[this.activeIndex].wap_poster,
    //     "poster" + this.activeIndex
    //   );
    // }
  }
};
</script>
